import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-profile-2-user',
  imports: [],
  templateUrl: './icon-profile-2-user.component.html',
})
export class IconProfile2UserComponent {
  @Input() color: string = '#fff';
  @Input() size: string = '24px';
}
